import Map from "../components/mapcomponents/basemap";
import { bgColors } from "../components/utils/bgColor";
import { useSelector } from "react-redux";
// import {mapStyleLlist} from "../components/FormComopents/Form/Const"
// const center = {lng:76,lat:22}
const pitch = 0
const bearing = 0
const marginright = 0
const Basemappage = () => {

const marginleft = useSelector(state => 
    state.controlbutton.mapconatiner_margin_left
    );

  

  return (
        <div className= "main" style={{backgroundColor:bgColors.sidpanel_grey}}>
         <Map
        // center = {center}
        // styleName={stylename}
        pitch= {pitch}
        bearing= {bearing}
        // marginleft = {marginleft}
        marginright = {marginright}
        preserveDrawingBuffer= {true}
        accessToken= {process.env.REACT_APP_MAPBOX_TOEKN}
        />
        </div>
       

  );
}

export default Basemappage










